import { CluesInGroup } from "./CrosswordUtils";
import { Clue } from "./models/clue";

export class ClueSpec {
  number: number = 0;
  direction: "across" | "down" | "both" | "none" = "none";
  selectedRow: number = 0;
  selectedCol: number = 0;

  constructor(
    num: number = 0,
    dir: "across" | "down" | "both" | "none" = "none",
    row: number = 0,
    col: number = 0
  ) {
    this.number = num;
    this.direction = dir;
    this.selectedRow = row;
    this.selectedCol = col;
  }
  isSet(): boolean {
    return this.number !== 0;
  }

  addClue(num: number, isAcross: boolean) {
    if (this.number === 0) {
      this.number = num;
      this.direction = isAcross ? "across" : "down";
    } else if (this.number === num) {
      this.direction = "across";  // selecting both is too confusing.  So go for across
    }
  }

  static singleClueContainsCell(row: number, col: number, clue: Clue | null) {
    if (clue === null) {
      return false;
    }
    if (clue.isAcross) {
      return (
        row === clue.row &&
        col >= clue.column &&
        col < clue.column + clue.length
      );
    } else {
      return (
        col === clue.column && row >= clue.row && row < clue.row + clue.length
      );
    }
  }

  containsCell(row: number, col: number, clues: Clue[]) {
    if (!this.isSet()) {
      return false;
    }
    const thisClue: Clue | null = clues.filter(
      (clue) =>
        clue.clueNumber === this.number &&
        clue.isAcross == (this.direction == "across")
    )[0];
    const group: Clue[] = CluesInGroup(clues, thisClue);
    for (const clue of group) {
      if (ClueSpec.singleClueContainsCell(row, col, clue)) {
        return true;
      }
    }

    if (this.direction === "both") {
        const thisOtherClue: Clue | null = clues.filter(
          (clue) =>
            clue.clueNumber === this.number &&
            clue.isAcross) [0];
        const group: Clue[] = CluesInGroup(clues, thisOtherClue);
        for (const clue of group) {
          if (ClueSpec.singleClueContainsCell(row, col, clue)) {
            return true;
          }
        }
    }
    return false;
  }
}
